export type FinancialStatus =
  | 'ready_for_payout'
  | 'on_review'
  | 'refused'
  | 'in_progress'
  | 'not_in_billing';

export const NO_FINANCIAL_STATUS_LABEL = '-';

export const financialStatusLabel = (status: FinancialStatus | null | undefined): string => {
  switch (status) {
    case 'in_progress':
      return 'In progress';
    case 'on_review':
      return 'On review';
    case 'refused':
      return 'Refused';
    default:
      return NO_FINANCIAL_STATUS_LABEL;
  }
};

export interface FinancialStatusCountFields {
  ready_for_payout_count?: number | null;
  on_review_count?: number | null;
  refused_count?: number | null;
  in_progress_count?: number | null;
}

export interface FinancialStatusCount {
  label: string;
  count: number;
}

interface FinancialStatusCountField {
  key: keyof FinancialStatusCountFields;
  label: string;
}

const FINANCIAL_STATUS_COUNT_FIELDS: readonly FinancialStatusCountField[] = [
  { key: 'ready_for_payout_count', label: 'Ready for payout' },
  { key: 'on_review_count', label: 'On review' },
  { key: 'refused_count', label: 'Refused' },
  { key: 'in_progress_count', label: 'In progress' },
];

export const financialStatusCounts = (
  stats: FinancialStatusCountFields
): FinancialStatusCount[] | null => {
  const counts: FinancialStatusCount[] = [];
  for (const field of FINANCIAL_STATUS_COUNT_FIELDS) {
    const count = stats[field.key];
    if (count == null) {
      return null;
    }
    counts.push({ label: field.label, count });
  }
  return counts;
};

export interface RefundedAmountRow {
  refunded_amount?: number | null;
}

export const hasRefundedAmount = (rows: ReadonlyArray<RefundedAmountRow>): boolean => {
  return rows.some(x => x.refunded_amount != null);
};
